import { FC } from 'react';
import { useCatalogEntryIARecommendation } from '@/data/Content/CatalogEntryIARecommendation';
import { CLICK_PRODUCT_VIEW_SOURCE } from '@/data/constants/clickProductView';
import { ProductType } from '@/data/types/Product';
import { DpIARecommendationResponse } from 'integration/generated/transactions/data-contracts';
import { useCatalogEntryIARecommendationItems } from '@/data/Content/CatalogEntryIARecommendationItems';
import { CatalogEntryFullRenderer } from '@/components/content/CatalogEntryIARecommendation/parts/CatalogEntryFullRenderer';
import { DpModernProductCardVariant } from '@/components/blocks/DpModernProductCard';

export const CatalogEntryIARecommendationFree: FC<{
	params: {
		partNumber?: string;
	};
	clickSource?: CLICK_PRODUCT_VIEW_SOURCE;
	variant?: DpModernProductCardVariant;
	partNumbersExtractor: (data: DpIARecommendationResponse) => string[];
	emptyExtractor: (products: ProductType[]) => boolean;
	render?: (component: React.ReactNode) => JSX.Element;
}> = ({ params, clickSource, variant = 'mini', partNumbersExtractor, emptyExtractor, render }) => {
	const { products, contract, isLoadingDpIARecommendation, isLoadingProducts } =
		useCatalogEntryIARecommendation({
			params,
			partNumbersExtractor,
		});

	const { slides } = useCatalogEntryIARecommendationItems({
		products,
		isLoadingProducts,
		parentPartNumber: params?.partNumber,
		variant,
		clickSource,
		contract,
		params,
	});

	if (!(isLoadingDpIARecommendation || isLoadingProducts) && emptyExtractor?.(products)) {
		return null;
	}

	if (render) {
		return render(<CatalogEntryFullRenderer slides={slides} />);
	}

	return <CatalogEntryFullRenderer slides={slides} />;
};
